"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMarginBottom = exports.footer = exports.logoImg = void 0;
const css_manager_1 = require("@food/css-manager");
exports.logoImg = (0, css_manager_1.registerClass)(() => `
	max-width: 100%;
	margin: auto;
	width: 100%;
`);
exports.footer = (0, css_manager_1.registerClass)((theme, sc) => `
	display: flex;
	justify-content: space-between;
	padding: 0;
	margin-top: ${theme.ratios.l * theme.font.baseSize}px;

	&.${sc('centered')} {
		justify-content: center;
	}
`);
exports.defaultMarginBottom = (0, css_manager_1.registerClass)((theme) => `margin-bottom: ${theme.ratios.l * theme.font.baseSize}px`);
//# sourceMappingURL=theme.js.map